import { createSlice } from "@reduxjs/toolkit";
var initialState = { size: undefined };
/** Размеры экрана храним глобально, переопределяем в DefaultLayout */
export var viewportSlice = createSlice({
    name: "appViewport",
    initialState: initialState,
    selectors: { isDesktop: function (state) { var _a; return ((_a = state.size) === null || _a === void 0 ? void 0 : _a.width) > 1024; } },
    reducers: {
        setViewportSize: function (state, action) {
            state.size = action.payload;
        },
    },
});
export var isDesktop = viewportSlice.selectors.isDesktop;
export var setViewportSize = viewportSlice.actions.setViewportSize;
var viewportReducer = viewportSlice.reducer;
export default viewportReducer;
